import { render } from "./WhereToRedeem.vue?vue&type=template&id=3cbf3b84&scoped=true"
import script from "./WhereToRedeem.vue?vue&type=script&lang=js"
export * from "./WhereToRedeem.vue?vue&type=script&lang=js"

import "./WhereToRedeem.vue?vue&type=style&index=0&id=3cbf3b84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbf3b84"]])

export default __exports__